import { connect } from "react-redux"
import * as Immutable from "immutable"

import {
    communityMembersListRequest,
    communityManagersListRequest,
    communityFollowersListRequest,
    communityInvitedListRequest,
    communityAwaitingApprovalListRequest
} from "../../../../../actions/community-participant-actions"
import CommunityViewInvitedListItem from "./CommunityViewInvitedListItem"
import InfiniteScroll from "../../../../common/InfiniteScroll"
import UserListItem from "../../../../common/UserListItem"
import UserListItemShadow from "../../../../common/UserListItemShadow"

function hasEmptyMessage(
    searchCriteria: Immutable.Map,
    type: boolean
): boolean {
    return !(type && searchCriteria && searchCriteria.get("name") === "")
}

const mapStateToProps = (
    { paging, presentation: { communities }, entities },
    { type, communityId }
) => {
    const pagingList = paging.communityParticipants[type]
    const searchCriteria =
        communities[`${communities.selectedParticipantType}SearchCriteria`]
    const pagingRequest = pagingList[searchCriteria] || {}
    const data = (pagingRequest.data || []).map(id => {
        const participant = entities.users[id]
        const is_manager = (participant.is_manager || {})[communityId]
        const isPromoted = participant[`isPromoted_${communityId}`]
        let labels = null
        if (is_manager || isPromoted) {
            labels = ["Manager"]
        }
        return {
            ...participant,
            labels
        }
    })

    return {
        itemComponent:
            communities.selectedParticipantType === "invited"
                ? CommunityViewInvitedListItem
                : UserListItem,
        shadowComponent: UserListItemShadow,
        data,
        isFetching: pagingRequest.isFetching,
        shouldDisplayShadow:
            pagingRequest.isFetching ||
            communities.isFetchingItem ||
            (communities.isFetchingList && !communities.activeId),
        pagingRequest,
        communityId,
        containerClassName: "widget-content list-group auto",
        shouldShowEmptyMessage: hasEmptyMessage(
            pagingRequest.searchCriteria,
            type
        )
    }
}

const mapDispatchToProps = (dispatch, { type, communityId }) => ({
    requestMoreData: pagingRequest => {
        switch (type) {
            case "managers":
                return dispatch(communityManagersListRequest(pagingRequest))
            case "followers":
                return dispatch(communityFollowersListRequest(pagingRequest))
            case "invited":
                return dispatch(communityInvitedListRequest(pagingRequest))
            case "awaiting_approval":
                return dispatch(
                    communityAwaitingApprovalListRequest(pagingRequest)
                )
            case "members":
            default:
                return dispatch(communityMembersListRequest(pagingRequest))
        }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(InfiniteScroll)
